module.exports = __webpack_public_path__ + "images/e329336dd2854032e949858242211d11-kitchen_drawers1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/kitchen_drawers1.jpg
// module id = ./src/assets/images/content/kitchen_drawers1.jpg
// module chunks = 0